import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DownloadIcon from "@mui/icons-material/Download";
import { Button, Stack } from "@mui/material";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import type { ECommerceOfferResponse } from "../../eCommerce/eCommerceApi";
import { useDownloadImages } from "../../misc/useDownloadImages";
import DownloadOrderPdfButton from "../../orders/DownloadOrderPdfButton";
import type { PackageImageDTO } from "../../publicPackages/publicPackagesApi";
import type { FormatType } from "../../publicPackages2/single-package/FormatSelector";
import { BookOfferButton } from "./BookOfferButton";

export function ECommerceActions(props: { offer: ECommerceOfferResponse; format: FormatType; onBack: () => void }) {
  const { download } = useDownloadImages();
  //const { images } = props.forPackage.media;
  const images: PackageImageDTO[] = [];

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", md: "center" },
        mb: 4,
      }}
    >
      <Button startIcon={<ArrowBackIcon />} onClick={props.onBack} sx={{ color: "text.secondary", fontWeight: "bold" }}>
        Wróć do listy
      </Button>
      <Stack
        direction="row"
        spacing={1.5}
        useFlexGap
        sx={{
          flexWrap: "wrap",
        }}
      >
        <AsyncLoadingButton
          variant="outlined"
          color="inherit"
          startIcon={<DownloadIcon />}
          sx={{ borderRadius: 6 }}
          disabled={images.length === 0}
          onClick={async () => {
            await download(images.map((i) => ({ name: i.name, url: i.original.url })));
          }}
        >
          Pobierz zdjęcia
        </AsyncLoadingButton>

        <DownloadOrderPdfButton orderId={props.offer.id.value} filename={`${props.offer.name}.pdf`} />

        <BookOfferButton offer={props.offer} />
      </Stack>
    </Stack>
  );
}
